export class ArrowPosition {
    constructor(x = 0, y = 0) {
        this.xAxis = x;
        this.yAxis = y;
    }
}
export class CameraPosition {
    constructor(x = 0, y = 0, fov = 140, sceneIndex = 0, tourSceneGuid) {
        this.fov = fov;
        this.xAxis = x;
        this.yAxis = y;
        this.sceneIndex = sceneIndex;
        this.tourSceneGuid = tourSceneGuid;
    }
}
